var _curry2 = /*#__PURE__*/require('./_curry2');

var _flatCat = /*#__PURE__*/require('./_flatCat');

var map = /*#__PURE__*/require('../map');

var _xchain = /*#__PURE__*/_curry2(function _xchain(f, xf) {
  return map(f, _flatCat(xf));
});
module.exports = _xchain;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_xchain.js
// module id = 344
// module chunks = 33587185282056 114276838955818